import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestCrossDismissDelete = {
    path: "/cross/:slug/:action/dismiss",
    method: RouteHttpVerb.DELETE
};
